import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackTranscriptSearchPreviousResultClicked.meta';

export type UseTrackTranscriptSearchPreviousResultClickedParams = {
  clip_id: string;
  search_term: string;
  new_index: number;
};

export const useTrackTranscriptSearchPreviousResultClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackTranscriptSearchPreviousResultClicked = useCallback(
    (params: UseTrackTranscriptSearchPreviousResultClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackTranscriptSearchPreviousResultClicked };
};
